import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Component,
  inject,
  ViewChild,
  OnInit,
  DestroyRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';

import {
  Action,
  ActionService,
  ActionsCreateModalComponent,
} from '../../../index';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { UpperCasePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SearchFieldComponent } from '@shared/components/search-field/search-field.component';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Component({
  templateUrl: './action-page.component.html',
  styles: [],
  standalone: true,
  imports: [
    ToolbarComponent,
    SearchFieldComponent,
    ButtonComponent,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatIconModule,
    MatPaginatorModule,
    UpperCasePipe,
  ],
})
export class ActionPageComponent implements OnInit {
  paginatorIntl: MatPaginatorIntl = new MatPaginatorIntl();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  fielInput: string = '';
  displayedColumns: string[] = [
    'name',
    'actioncode',
    'description',
    'type',
    'options',
  ];
  dataSource: MatTableDataSource<Action>;

  private dialog = inject(MatDialog);
  private actionService = inject(ActionService);
  private destroyRef = inject(DestroyRef);

  constructor() {
    this.paginatorIntl = new MatPaginatorIntl();
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit(): void {
    this.init();
  }

  private init() {
    this.actionService
      .getActions()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((request: any) => {
        if (request.status == 'OK') {
          this.dataSource = new MatTableDataSource<Action>(request.reply);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          if (this.paginator) {
            this.paginator._intl.itemsPerPageLabel = 'Registros por página';
            this.paginator._intl.nextPageLabel = 'Página siguiente ';
            this.paginator._intl.previousPageLabel = 'Página anterior';
            this.paginator._intl.firstPageLabel = 'Primera página';
            this.paginator._intl.lastPageLabel = 'Última página';
            // Configuración del texto de la última página
            this.paginator._intl.getRangeLabel = (
              page: number,
              pageSize: number,
              length: number
            ) => {
              if (length === 0 || pageSize === 0) {
                return `0 de ${length}`;
              }
              length = Math.max(length, 0);
              const startIndex = page * pageSize;
              const endIndex =
                startIndex < length
                  ? Math.min(startIndex + pageSize, length)
                  : startIndex + pageSize;
              return `${startIndex + 1} - ${endIndex} de ${length}`;
            };
          }
        }
      });
  }

  modalAction(action?: Action) {
    const dialogActionDetail = this.dialog.open(ActionsCreateModalComponent, {
      width: '60%',
      data: action,
      disableClose: true,
    });
    dialogActionDetail
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(request => {
        if (request) {
          this.init();
        }
      });
  }
}
